const fCamelToSnake = p => {
  return p.replace(/([A-Z])/g, s => '_' + s.charAt(0).toLowerCase())
}
export default class {
  static install(Vue) {
    Vue.prototype.$sendEventToGA = (eventName, eventDetail) => {
      // GAのログはsnakeなので、snakeに統一する
      const snakedEventName = fCamelToSnake(eventName)
      const snakedEventDetail = fCamelToSnake(JSON.stringify(eventDetail))

      window.dataLayer.push({
        event: snakedEventName,
        event_detail: snakedEventDetail,
      })
    }

    Vue.prototype.$sendUserIdToGA = userId => {
      window.dataLayer.push({
        user_id: userId,
      })
    }
  }
}
